import { StatusEnum } from "common/constants";
import type { CanViewSmartSurveyorReview } from "./types";

export const canViewSmartSurveyorReview: CanViewSmartSurveyorReview = ({
  status,
  isSuperAdmin,
}) => {
  if (status === StatusEnum.DONE) return true;
  if (status === StatusEnum.IN_VALIDATION && isSuperAdmin) return true;
  return false;
};
